/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rental_Checkin_LabelInputs */

const en_rental_checkin_label = /** @type {(inputs: Rental_Checkin_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Check-In`)
};

const es_rental_checkin_label = /** @type {(inputs: Rental_Checkin_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Check-In`)
};

const fr_rental_checkin_label = /** @type {(inputs: Rental_Checkin_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Arrivée`)
};

const de_rental_checkin_label = /** @type {(inputs: Rental_Checkin_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Check-in`)
};

const id_rental_checkin_label = /** @type {(inputs: Rental_Checkin_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Check-In`)
};

/** @type {(inputs: Rental_Checkin_LabelInputs) => LocalizedString} */
const ja_rental_checkin_label = en_rental_checkin_label;

/** @type {(inputs: Rental_Checkin_LabelInputs) => LocalizedString} */
const zh_rental_checkin_label = en_rental_checkin_label;

/** @type {(inputs: Rental_Checkin_LabelInputs) => LocalizedString} */
const ar_rental_checkin_label = en_rental_checkin_label;

/** @type {(inputs: Rental_Checkin_LabelInputs) => LocalizedString} */
const it_rental_checkin_label = en_rental_checkin_label;

/** @type {(inputs: Rental_Checkin_LabelInputs) => LocalizedString} */
const ru_rental_checkin_label = en_rental_checkin_label;

/** @type {(inputs: Rental_Checkin_LabelInputs) => LocalizedString} */
const pt_rental_checkin_label = en_rental_checkin_label;

/** @type {(inputs: Rental_Checkin_LabelInputs) => LocalizedString} */
const ko_rental_checkin_label = en_rental_checkin_label;

/**
* | output |
* | --- |
* | "Check-In" |
*
* @param {Rental_Checkin_LabelInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const rental_checkin_label = /** @type {((inputs?: Rental_Checkin_LabelInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rental_Checkin_LabelInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_rental_checkin_label(inputs)
	if (locale === "es") return es_rental_checkin_label(inputs)
	if (locale === "fr") return fr_rental_checkin_label(inputs)
	if (locale === "de") return de_rental_checkin_label(inputs)
	if (locale === "ja") return ja_rental_checkin_label(inputs)
	if (locale === "zh") return zh_rental_checkin_label(inputs)
	if (locale === "ar") return ar_rental_checkin_label(inputs)
	if (locale === "id") return id_rental_checkin_label(inputs)
	if (locale === "it") return it_rental_checkin_label(inputs)
	if (locale === "ru") return ru_rental_checkin_label(inputs)
	if (locale === "pt") return pt_rental_checkin_label(inputs)
	return ko_rental_checkin_label(inputs)
});